<template>
    <div>
        <v-snackbar v-model="snackbar" :color="snackColor" :timeout="3000" top>
            <v-row>
                <span>{{ snackText }}</span>
                <v-spacer />
                <v-btn icon @click.native="snackbar = false">
                    <v-icon color="white">mdi-close</v-icon>
                </v-btn>
            </v-row>
        </v-snackbar>

        <v-container>
            <v-card class="pa-6 rounded-xl" elevation="2" max-width="640">
                <div class="d-flex align-center mb-2">
                    <v-icon color="orange" class="mr-2">mdi-cash-multiple</v-icon>
                    <span class="text-h6 font-weight-bold">Hotel Fee Settings</span>
                </div>
                <p class="text-body-2 grey--text mb-6">
                    These percentages are added on top of the TGX hotel base price and charged to the customer.
                    Both fees are <strong>non-refundable</strong> on cancellation.
                </p>

                <v-skeleton-loader v-if="loading" type="list-item-two-line, list-item-two-line" />

                <template v-else>
                    <!-- PayFort Commission -->
                    <v-card outlined class="pa-4 mb-4 rounded-lg">
                        <div class="text-subtitle-2 font-weight-bold mb-1">PayFort Commission</div>
                        <div class="text-caption grey--text mb-3">{{ payfortRow.description }}</div>
                        <v-row align="center">
                            <v-col cols="8">
                                <v-text-field
                                    v-model.number="payfortRow.amount"
                                    label="Percentage (%)"
                                    type="number"
                                    min="0"
                                    max="100"
                                    step="0.01"
                                    outlined
                                    dense
                                    color="orange"
                                    suffix="%"
                                />
                            </v-col>
                            <v-col cols="4">
                                <v-btn
                                    color="orange white--text"
                                    :loading="savingPayfort"
                                    block
                                    @click="save('payfort')"
                                >
                                    Save
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>

                    <!-- Tanefer Margin -->
                    <v-card outlined class="pa-4 rounded-lg">
                        <div class="text-subtitle-2 font-weight-bold mb-1">Tanefer Profit Margin</div>
                        <div class="text-caption grey--text mb-3">{{ taneferRow.description }}</div>
                        <v-row align="center">
                            <v-col cols="8">
                                <v-text-field
                                    v-model.number="taneferRow.amount"
                                    label="Percentage (%)"
                                    type="number"
                                    min="0"
                                    max="100"
                                    step="0.01"
                                    outlined
                                    dense
                                    color="orange"
                                    suffix="%"
                                />
                            </v-col>
                            <v-col cols="4">
                                <v-btn
                                    color="orange white--text"
                                    :loading="savingTanefer"
                                    block
                                    @click="save('tanefer')"
                                >
                                    Save
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                </template>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import { profitSettings, updateProfitSetting, headers } from '../../links'

export default {
  name: 'FeeSettings',
  data () {
    return {
      loading: true,
      savingPayfort: false,
      savingTanefer: false,
      snackbar: false,
      snackColor: 'success',
      snackText: '',
      payfortRow: { id: null, amount: 0, description: '' },
      taneferRow: { id: null, amount: 0, description: '' }
    }
  },
  created () {
    this.fetchSettings()
  },
  methods: {
    fetchSettings () {
      this.loading = true
      this.$http.get(profitSettings, { headers: headers(this.$cookies.get('userToken')) })
        .then(res => {
          this.loading = false
          const rows = res.body.data || res.body || []
          const payfort = rows.find(r => r.target === 'hotel_payfort_commission')
          const tanefer = rows.find(r => r.target === 'hotel_tanefer_margin')
          if (payfort) { this.payfortRow = { id: payfort.id, amount: Number(payfort.amount), description: payfort.description || '' } }
          if (tanefer) { this.taneferRow = { id: tanefer.id, amount: Number(tanefer.amount), description: tanefer.description || '' } }
        })
        .catch(() => {
          this.loading = false
          this.showSnack('Failed to load fee settings.', 'error')
        })
    },
    save (which) {
      const row = which === 'payfort' ? this.payfortRow : this.taneferRow
      if (!row.id) {
        this.showSnack('Setting not found. Please run the database seeder.', 'error')
        return
      }
      const savingKey = which === 'payfort' ? 'savingPayfort' : 'savingTanefer'
      this[savingKey] = true
      this.$http.put(
        updateProfitSetting(row.id),
        JSON.stringify({ amount: row.amount }),
        { headers: headers(this.$cookies.get('userToken')) }
      ).then(res => {
        this[savingKey] = false
        if (res.status === 200) {
          this.showSnack('Fee updated successfully.', 'success')
        } else {
          this.showSnack((res.body && res.body.message) || 'Update failed.', 'error')
        }
      }).catch(err => {
        this[savingKey] = false
        this.showSnack((err.body && err.body.message) || 'Update failed.', 'error')
      })
    },
    showSnack (text, color) {
      this.snackText = text
      this.snackColor = color
      this.snackbar = true
    }
  }
}
</script>
